import React from "react";
import { SealCheck } from "@phosphor-icons/react";

export default function VerifiedBadge({ size = 14, className = "" }) {
  return (
    <SealCheck
      size={size}
      weight="fill"
      className={`text-primary inline-block align-middle ${className}`}
      data-testid="verified-badge"
      aria-label="Verified"
    />
  );
}
